var isDev = process.env.NODE_ENV === 'development';

export { isDev as default };
//# sourceMappingURL=index.js.map
